import React, { useEffect, useState } from 'react'
import Configurator from '../configurator'
import { database } from '../components/shared/database'
import DatePicker from 'react-date-picker'
import { withRouter } from '../validator'
import { Link } from 'react-router-dom'

const initForm = {
    name: '',
    dateTo: new Date(),
    buyAt: new Date(),
}

const FoodFormDate = ({
    food,
    match,
}) => {
    const [name, setName] = useState('')
    const [dateTo, setDateTo] = useState(new Date())
    const [buyAt, setBuyAt] = useState(new Date())
    const [countFood, setCountFood] = useState(1)

    useEffect(() => {
        if (food?.uidFood) {
            setName(food?.name || '')
            setDateTo(food?.dateTo || new Date())
            setBuyAt(food?.buyAt || new Date())
            setCountFood(food?.countFood ?? 1)
        }

        loadFridge()
    }, [food])

    useEffect(() => {
        loadFridge()
    }, [match.params.fridge])


    const loadFridge = () => {
        return database('fridge')
            .doc(match.params.fridge)
            .get()
            .then(snapshot => {
                const data = snapshot.data()

                setName(data.name)
            })
    }

    const saveForm = async event => {
        event.preventDefault()

        const uidFridge = match.params.fridge

        await database('fridge')
            .doc(uidFridge)
            .update({
                dateTo: window.moment(dateTo).format('L'),
                dateToTimestamp: window.moment(dateTo).format('x'),
                buyAt: window.moment(buyAt).format('L'),
                countFood: countFood,
            })

        setName('')
        setDateTo(new Date())
        setBuyAt(new Date())
        setCountFood(1)

        window.location.href = '/cs/add'
    }

    return (
        <div className="p-3">
            <h2>{name}</h2>
            <form onSubmit={saveForm} className="position-relative">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="mb-3">
                            <label htmlFor="form-date-to" className="form-label">
                                Spotřebovat do
                            </label>
                            <DatePicker
                                type="text"
                                className="form-control"
                                id="form-date-to"
                                value={dateTo}
                                onChange={value => setDateTo(value)}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="form-buy-at" className="form-label">
                                Datum koupě
                            </label>
                            <DatePicker
                                type="text"
                                className="form-control"
                                id="form-buy-at"
                                value={buyAt}
                                onChange={value => setBuyAt(value)}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="count-food" className="form-label">
                                Počet kusů
                            </label>
                            <input
                                type="number"
                                onChange={event => setCountFood(event.target.value)}
                                value={countFood}
                                className="form-control"
                                id="count-food"
                            />
                        </div>
                    </div>
                </div>
                <div style={{ position: 'relative', bottom: 0, width: '100%', left: 0 }}>
                    <Link to="/" className="btn btn-outline-warning col-6">Uložit a skončit</Link>
                    <button type="submit" className="btn btn-primary col-6">Uložit a zadat další</button>
                </div>
            </form>
        </div>
    )
}

export default withRouter()(FoodFormDate)

